import Button from '@asphalt-react/button';
import React from 'react';
import { useHistory } from 'react-router-dom';
import notFound from '../../assets/notFound.svg';

function NotFoundPage() {
    const notFoundPageContainerStyle = {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
    };
    const headingExtraLargeTextStyle = {
        color: 'rgb(36, 54, 88)',
        fontSize: '21px',
        fontWeight: '600',
        lineHeight: '29px',
        textAlign: 'center',
        marginBottom: '8px',
    };

    const bodyMediumTextStyle = {
        color: 'rgb(130, 146, 176)',
        fontSize: '16px',
        fontWeight: '300',
        lineHeight: '22px',
        textAlign: 'center',
        marginBottom: '32px',
    };

    const imageStyle = {
        marginBottom: '40px',
    };

    let history = useHistory();

    return (
        <div style={notFoundPageContainerStyle}>
            <img style={imageStyle} src={notFound} alt={'page not found'} />
            <p style={headingExtraLargeTextStyle}>404 page not found</p>
            <p style={bodyMediumTextStyle}>
                The page you were looking for, could not be found on this
                server.
            </p>
            <Button
                onClick={() => {
                    history.replace(`/`);
                }}>
                Go home
            </Button>
        </div>
    );
}

export default NotFoundPage;
